export default "__VITE_ASSET__CZD25ifc__"